/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Selected_TitleInputs */

const en_tags_selected_title = /** @type {(inputs: Tags_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selected Style Guide`)
};

const fr_tags_selected_title = /** @type {(inputs: Tags_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide de style selectionne`)
};

const de_tags_selected_title = /** @type {(inputs: Tags_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählter Styleguide`)
};

const it_tags_selected_title = /** @type {(inputs: Tags_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guida di stile selezionata`)
};

const ru_tags_selected_title = /** @type {(inputs: Tags_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Руководство по выбору стиля`)
};

const es_tags_selected_title = /** @type {(inputs: Tags_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guía de estilo seleccionada`)
};

const zh_cn2_tags_selected_title = /** @type {(inputs: Tags_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选风格指南`)
};

const ja_tags_selected_title = /** @type {(inputs: Tags_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択されたスタイルガイド`)
};

const hi_tags_selected_title = /** @type {(inputs: Tags_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित शैली मार्गदर्शिका`)
};

const pt_pt2_tags_selected_title = /** @type {(inputs: Tags_Selected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guia de Estilo Selecionado`)
};

/**
* | output |
* | --- |
* | "Selected Style Guide" |
*
* @param {Tags_Selected_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_selected_title = /** @type {((inputs?: Tags_Selected_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Selected_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_selected_title(inputs)
	if (locale === "de") return de_tags_selected_title(inputs)
	if (locale === "it") return it_tags_selected_title(inputs)
	if (locale === "ru") return ru_tags_selected_title(inputs)
	if (locale === "es") return es_tags_selected_title(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_selected_title(inputs)
	if (locale === "ja") return ja_tags_selected_title(inputs)
	if (locale === "hi") return hi_tags_selected_title(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_selected_title(inputs)
	return en_tags_selected_title(inputs)
});